import { openDialog } from "vue3-promise-dialog";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";

export async function confirmDialog(
  title: string,
  text: string,
  confirmLabel?: string,
  cancelLabel?: string
) {
  return await openDialog(ConfirmModal, {
    title,
    text,
    confirmLabel,
    cancelLabel,
  });
}
